webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(69);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(63);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueProgressbar = __webpack_require__(28);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueProgressbar2.default, {
	  debug: true,
	  color: '#bffaf3',
	  failedColor: '#CF2020',
	  thickness: '5px',
	  transition: {
	    time: '0.7s',
	    opacity: '0.6s'
	  },
	  trail: '100px',
	  autoRevert: true,
	  location: 'top',
	  inverse: false,
	  gradient: {
	    use: false,
	    gradient: 'predefined'
	  },
	  init: true
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: {
	    App: _App2.default
	  }
	});

/***/ },

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(64);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Hello: _Hello2.default
	  }
	};

/***/ },

/***/ 25:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  mounted: function mounted() {
	    this.$pb.start('example');
	  },
	  data: function data() {
	    return {
	      checkboxes: { transition: 'Transition', trail: 'Trail', fColor: 'Fail Color', sColor: 'Color', gradient: 'Gradient', bounce: 'Bounce', inverse: 'Inverse', thickness: 'Thickness' },
	      locations: { options: ['top', 'bottom', 'left', 'right'], location: 'top' },
	      failColor: { use: false, data: '' },
	      color: { use: false, data: '' },
	      gradient: { use: false, data: '' },
	      inverse: { use: false },
	      bounce: { use: false },
	      transition: { use: false, time: '', opacity: '' },
	      trail: { use: false, data: '' },
	      thickness: { use: false, data: '' }
	    };
	  },
	
	  methods: {
	    start: function start(bName) {
	      var modifications = [];
	      this.failColor.use ? modifications.push({ call: 'fail', modifier: 'temp', argument: this.failColor.data }) : modifications.push({ call: 'fail', modifier: 'temp', argument: '#ff0000' });
	      this.color.use ? modifications.push({ call: 'color', modifier: 'temp', argument: this.color.data }) : modifications.push({ call: 'color', modifier: 'temp', argument: '#178BA1' });
	      this.gradient.use ? modifications.push({ call: 'gradient', modifier: 'temp', argument: { use: this.gradient.use, gradient: this.gradient.data } }) : null;
	      this.inverse.use ? modifications.push({ call: 'inverse', modifier: 'temp', argument: true }) : modifications.push({ call: 'inverse', modifier: 'temp', argument: false });
	      this.bounce.use ? modifications.push({ call: 'bounce', modifier: 'temp', argument: true }) : modifications.push({ call: 'bounce', modifier: 'temp', argument: false });
	      this.transition.use ? modifications.push({ call: 'transition', modifier: 'temp', argument: { time: this.transition.time + 's', opacity: this.transition.opacity + 's' } }) : null;
	      this.trail.use && this.trail.data !== '' ? modifications.push({ call: 'trail', modifier: 'temp', argument: this.trail.data + 'px' }) : modifications.push({ call: 'trail', modifier: 'temp', argument: '-1px' });
	      this.thickness.use && this.thickness.data !== '' ? modifications.push({ call: 'thickness', modifier: 'temp', argument: this.thickness.data + 'px' }) : modifications.push({ call: 'thickness', modifier: 'temp', argument: '20px' });
	      modifications.push({ call: 'location', modifier: 'temp', argument: this.locations.location });
	      this.$pb.start(bName, modifications, 'meta');
	    },
	    finish: function finish(bName) {
	      this.$pb.finish(bName);
	    },
	    fail: function fail(bName) {
	      this.$pb.fail(bName);
	    }
	  }
	};

/***/ },

/***/ 26:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gradientClasses = __webpack_require__(27);
	
	var _gradientClasses2 = _interopRequireDefault(_gradientClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inBrowser = typeof window !== 'undefined';
	
	exports.default = {
	  name: 'VueProgress',
	  serverCacheKey: function serverCacheKey(props) {
	    return 'Progress-' + props.reference;
	  },
	  props: ['reference', 'options', 'show'],
	  data: function data() {
	    return {
	      progression: -1,
	      canUpdate: true,
	      defaultData: {
	        init: true,
	        initiated: false,
	        started: false,
	        finished: false,
	        percent: 0,
	        hidden: true,
	        progression: 0,
	        quickHide: false,
	        quicklyHid: false,
	        temp: {
	          gradient: {
	            use: false,
	            gradient: ''
	          },
	          use: false,
	          autoRevert: true,
	          canSuccess: true,
	          color: 'rgb(19, 91, 55)',
	          debug: false,
	          failedColor: 'red',
	          inverse: false,
	          location: 'top',
	          show: false,
	          thickness: '2px',
	          trail: '-1px',
	          transition: {
	            time: '0.2s',
	            opacity: '0.6s'
	          },
	          bounce: false
	        },
	        options: {
	          gradient: {
	            use: false,
	            gradient: ''
	          },
	          autoRevert: true,
	          canSuccess: true,
	          color: 'rgb(19, 91, 55)',
	          debug: false,
	          failedColor: 'red',
	          inverse: false,
	          location: 'top',
	          show: false,
	          thickness: '2px',
	          trail: '-1px',
	          transition: {
	            time: '0.2s',
	            opacity: '0.6s'
	          },
	          bounce: false
	        }
	      }
	    };
	  },
	  created: function created() {
	    if (this.$pb.version()) {
	      this.$pb.create(this.reference, this.options);
	    } else {
	      this.canUpdate = false;
	    }
	  },
	
	  methods: {
	    generateGradient: function generateGradient() {
	      var length = 0;
	      for (var variable in _gradientClasses2.default.classes) {
	        if (_gradientClasses2.default.classes.hasOwnProperty(variable)) {
	          length++;
	        }
	      }
	      var x = _gradientClasses2.default.classes[Math.floor(Math.random() * (length - 5)) + 5];
	      return x;
	    }
	  },
	  computed: {
	    style: function style() {
	      var progression = this.bar.progression;
	      var bar = this.bar.data;
	      if (this.canUpdate && bar.initiated) {
	        var qHide = bar.quickHide;
	        var hidden = bar.hidden;
	        var percent = bar.percent;
	        var options = !bar.temp.use ? bar.options : bar.temp;
	        var opacity = options.show ? 1 : 0;
	        var bounce = options.bounce;
	        var trail = parseFloat(options.trail.replace('/(px)/'));
	        var position = options.location;
	        var gradient = options.gradient;
	        var inverse = options.inverse;
	        var transitionTime = options.transition.time;
	        var opacityTime = options.transition.opacity;
	        var thickness = options.thickness;
	        var style = {};
	        style.opacity = opacity;
	        this.classStyle = '__cov-progress ';
	        if (!gradient.use) {
	          options.canSuccess ? style['background-color'] = options.color : style['background-color'] = options.failedColor;
	        } else if (gradient.use && !qHide) {
	          var regexGradient = new RegExp('(predefined)|((linear-gradient)\\(to (top|bottom|left|right), (rgb\\([0-9]{1,3}, [0-9]{1,3}, [0-9]{1,3}\\)|#[a-zA-Z0-9]{6}|#[a-zA-Z0-9]{3}|), (rgb\\([0-9]{1,3}, [0-9]{1,3}, [0-9]{1,3}\\)|#[a-zA-Z0-9]{6}|#[a-zA-Z0-9]{3}|)\\))');
	          if (progression !== this.progression) {
	            this.progression = progression;
	            if (gradient.gradient === 'predefined') {
	              gradient.gradient = this.generateGradient();
	            }
	          }
	          if (options.canSuccess) {
	            if (_gradientClasses2.default.classes.includes(gradient.gradient)) {
	              this.classStyle += gradient.gradient + ' ';
	            } else if (regexGradient.test(gradient.gradient)) {
	              style['background'] = gradient.gradient;
	            }
	          } else {
	            style['background'] = options.failedColor;
	          }
	        }
	        if (position === 'top' || position === 'bottom') {
	          position === 'top' ? style.top = '0px' : style.bottom = '0px';
	          if (!qHide) {
	            style.transition = 'width ' + transitionTime + ', margin ' + transitionTime + ', height 1ms, left ' + transitionTime + ', right ' + transitionTime + ', opacity ' + opacityTime;
	            if (inverse) {
	              this.classStyle += 'right ';
	              if (trail >= 0) {
	                style.width = trail + 'px';
	                style.margin = '0 ' + percent + 'vw 0 ' + -1 * percent + 'vw';
	                if (percent <= (window.innerWidth - (window.innerWidth - trail)) / 100) {
	                  style.right = -1 * trail + 'px';
	                } else {
	                  style.right = '0px';
	                }
	              } else {
	                style.right = '0px';
	                style.width = percent + '%';
	              }
	            } else {
	              this.classStyle += 'left ';
	              if (trail >= 0) {
	                style.width = trail + 'px';
	                style.margin = '0 ' + -1 * percent + 'vw 0 ' + percent + 'vw';
	                if (percent <= (window.innerWidth - (window.innerWidth - trail)) / 100) {
	                  style.left = -1 * trail + 'px';
	                } else {
	                  style.left = '0px';
	                }
	              } else {
	                style.left = '0px';
	                style.width = percent + '%';
	              }
	            }
	            style.height = thickness;
	          }
	          if (qHide || hidden) {
	            style.transition = 'height 1ms, margin 1ms, width 1ms, top 1ms, bottom 1ms, left 1ms, right 1ms, opacity 1ms';
	            style.opacity = 0;
	            inverse ? style.right = '0px' : style.left = '0px';
	            style.width = '0px';
	            style.height = '0px';
	          }
	        } else if (position === 'left' || position === 'right') {
	          position === 'left' ? style.left = '0px' : style.right = '0px';
	          if (!qHide) {
	            style.transition = 'left ' + transitionTime + ', height ' + transitionTime + ', margin ' + transitionTime + ', width 1ms, top ' + transitionTime + ', bottom ' + transitionTime + ', opacity ' + opacityTime;
	            if (inverse) {
	              this.classStyle += 'top side ';
	              if (trail >= 0) {
	                style.height = trail + 'px';
	                style.margin = percent + 'vh 0 ' + -1 * percent + 'vh 0';
	                if (percent <= (window.innerHeight - (window.innerHeight - trail)) / 100) {
	                  style.top = -1 * trail + 'px';
	                } else {
	                  style.top = '0px';
	                }
	              } else {
	                style.height = percent + '%';
	                style.top = '0px';
	              }
	            } else {
	              this.classStyle += 'bottom side ';
	              if (trail >= 0) {
	                style.height = trail + 'px';
	                style.margin = -1 * percent + 'vh 0 ' + percent + 'vh 0';
	                if (percent <= (window.innerHeight - (window.innerHeight - trail)) / 100) {
	                  style.bottom = -1 * trail + 'px';
	                } else {
	                  style.bottom = '0px';
	                }
	              } else {
	                style.height = percent + '%';
	                style.bottom = '0px';
	              }
	            }
	            style.width = thickness;
	          }
	          if (qHide || hidden) {
	            style.transition = 'width 1ms, margin 1ms, height 1ms, left 1ms, right 1ms, top 1ms, bottom 1ms, opacity 1ms';
	            style.opacity = 0;
	            inverse ? style.top = '0px' : style.bottom = '0px';
	            style.height = '0px';
	            style.width = '0px';
	          }
	        }
	        return style;
	      }
	      return {};
	    },
	    bar: function bar() {
	      if (this.$pb.version()) {
	        var bar = this.$pb.get(this.reference);
	        if (bar !== null) {
	          return bar.progressions[bar.progression];
	        } else {
	          return this.defaultData;
	        }
	      }
	    }
	  }
	};

/***/ },

/***/ 27:
/***/ function(module, exports) {

	'use strict';
	
	var classes = ['vicecity', 'mild', 'dawn', 'ibizasunset', 'eightiespurple', 'blackrosé', 'bradybradyfunfun', 'edssunsetgradient', 'snapchat', 'cosmicfusion', 'nepal', 'azurepop', 'lovecouple', 'disco', 'limeade', 'dania', 'fiftyshadesofgrey', 'dusk', 'iiitdelhi', 'sunonthehorizon', 'bloodred', 'sherbert', 'firewatch', 'lush', 'frost', 'mauve', 'royal', 'minimalred', 'dusk', 'deepseaspace', 'grapefruitsunset', 'sunset', 'solidvault', 'brightvault', 'politics', 'sweetmorning', 'sylvia', 'transfile', 'tranquil', 'redocean', 'shahabi', 'alihossein', 'ali', 'purplewhite', 'colorsofsky', 'decent', 'deepspace', 'darkskies', 'suzy', 'superman', 'nighthawk', 'forest', 'miamidolphins', 'minnesotavikings', 'christmas', 'joomla', 'pizelex', 'haikus', 'palewood', 'purplin', 'inbox', 'blush', 'backtothefuture', 'poncho', 'greenandblue', 'lightorange', 'netflix', 'littleleaf', 'deeppurple', 'backtoearth', 'mastercard', 'clearsky', 'passion', 'timber', 'betweennightandday', 'sagepersuasion', 'lizard', 'piglet', 'darkknight', 'curiosityblue', 'ukraine', 'greentodark', 'freshturboscent', 'kokocaramel', 'virginamerica', 'portrait', 'turquoiseflow', 'vine', 'flickr', 'instagram', 'twitch', 'pastelorangeatthesun', 'endlessriver', 'predawn', 'purplebliss', 'talkingtomiceelf', 'hersheys', 'crazyorangei', 'betweentheclouds', 'metallictoad', 'martini', 'friday', 'servquick', 'behongo', 'soundcloud', 'facebookmessenger', 'shore', 'cheerupemokid', 'amethyst', 'manofsteel', 'neonlife', 'teallove', 'redmist', 'starfall', 'dancetoforget', 'parklife', 'cherryblossoms', 'shadownight', 'ash', 'virgin', 'earthly', 'dirtyfog', 'thestrain', 'reef', 'candy', 'autumn', 'winter', 'foreverlost', 'almost', 'moor', 'aqualicious', 'mistymeadow', 'kyoto', 'siriustamed', 'jonquil', 'petrichor', 'alostmemory', 'vasily', 'blurrybeach', 'namn', 'daytripper', 'pinotnoir', 'miaka', 'army', 'shrimpy', 'influenza', 'calmdarya', 'bourbon', 'stellar', 'clouds', 'moonrise', 'peach', 'dracula', 'mantle', 'titanium', 'opa', 'seablizz', 'midnightcity', 'mystic', 'shroomhaze', 'moss', 'borabora', 'veniceblue', 'electricviolet', 'kashmir', 'steelgray', 'mirage', 'juicyorange', 'mojito', 'cherry', 'pinky', 'seaweed', 'purpleparadise', 'sunrise', 'aquamarine', 'aubergine', 'bloodymary', 'mangopulp', 'frozen', 'rosewater', 'horizon', 'lemontwist', 'emeraldwater', 'intuitivepurple', 'greenbeach', 'sunnydays', 'playingwithreds', 'harmonicenergy', 'coolbrown', 'youtube', 'noontodusk', 'nimvelo'];
	module.exports = {
	  classes: classes
	};

/***/ },

/***/ 28:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault2(_getIterator2);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueProgressbar = __webpack_require__(65);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var dProgressbar = function dProgressbar() {
	  var p = {
	    $root: null,
	    state: {
	      pTime: null,
	      settings: null,
	      timer: null,
	      hideTimer: null,
	      hideTimer2: null,
	      revertTimer: null,
	      cut: 0,
	      stages: null
	    },
	    log: function log(message) {
	      return fLog(this, message);
	    },
	    init: function init(data) {
	      return fInit(this, data);
	    },
	    start: function start(time) {
	      return fStart(this, time);
	    },
	    set: function set(num) {
	      return fSet(this, num);
	    },
	    get: function get() {
	      return fGet(this);
	    },
	    increase: function increase(num) {
	      return fIncrease(this, num);
	    },
	    decrease: function decrease(num) {
	      return fDecrease(this, num);
	    },
	    readyToRevert: function readyToRevert() {
	      return fReadyToRevert(this);
	    },
	    revert: function revert() {
	      return fRevert(this);
	    },
	    quickHide: function quickHide() {
	      return fQuickHide(this);
	    },
	    hide: function hide() {
	      return fHide(this);
	    },
	    pause: function pause() {
	      return fPause(this);
	    },
	    finish: function finish() {
	      return fFinish(this);
	    },
	    fail: function fail() {
	      return fFail(this);
	    },
	    callMeta: function callMeta() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return fCallMeta(this, args);
	    },
	    callSetTemp: function callSetTemp() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return fCallSetTemp(this, args);
	    },
	    callRevert: function callRevert(revert) {
	      return fCallRevert(this, revert);
	    },
	    call: function call() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return fCall(this, args);
	    },
	    parseMeta: function parseMeta(meta) {
	      return fParseMeta(this, meta);
	    },
	    randomize: function randomize(meta) {
	      return fRandomize(this, meta);
	    },
	    progress: function progress(bar, options) {
	      return fProgress(bar, options);
	    }
	  };
	  return p;
	};
	var dProgression = function dProgression(progression, options) {
	  var uuid = gUUID('##-#-#');
	  if (options === undefined || options === null) {
	    options = {};
	  }
	  return {
	    identifier: uuid,
	    progression: progression,
	    data: dBardata(options),
	    bar: dProgressbar()
	  };
	};
	var dBardata = function dBardata(options) {
	  var d = {
	    init: options.init !== undefined ? options.init : true,
	    initiated: false,
	    started: false,
	    finished: false,
	    percent: 0,
	    hidden: true,
	    quickHide: false,
	    quicklyHid: false,
	    temp: {
	      gradient: {
	        use: false,
	        gradient: 'predefined'
	      },
	      use: false,
	      autoRevert: true,
	      canSuccess: true,
	      color: 'rgb(19, 91, 55)',
	      debug: false,
	      failedColor: '#FF0000',
	      inverse: false,
	      location: 'top',
	      show: false,
	      thickness: '2px',
	      trail: '-1px',
	      transition: {
	        time: '0.2s',
	        opacity: '0.6s'
	      },
	      bounce: false,
	      init: true
	    },
	    options: {
	      gradient: options.gradient !== undefined ? options.gradient : {
	        use: false,
	        gradient: 'predefined'
	      },
	      autoRevert: options.autoRevert !== undefined ? options.autoRevert : true,
	      canSuccess: true,
	      color: options.color || 'rgb(19, 91, 55)',
	      debug: options.debug !== undefined ? options.debug : false,
	      failedColor: options.failedColor !== undefined ? options.failedColor : '#FF0000',
	      inverse: options.inverse !== undefined ? options.inverse : false,
	      location: options.location !== undefined ? options.location : 'top',
	      show: false,
	      thickness: options.thickness !== undefined ? options.thickness : '2px',
	      trail: options.trail !== undefined ? options.trail : '-1px',
	      transition: options.transition !== undefined ? options.transition : {
	        time: '0.2s',
	        opacity: '0.6s'
	      },
	      bounce: options.bounce !== undefined ? options.bounce : false,
	      init: true
	    }
	  };
	  return d;
	};
	var gProgressBar = function gProgressBar() {
	  var name = (arguments.length <= 0 ? undefined : arguments[0]) !== null ? arguments.length <= 0 ? undefined : arguments[0] : null;
	  var options = (arguments.length <= 1 ? undefined : arguments[1]) !== null ? arguments.length <= 1 ? undefined : arguments[1] : {};
	  var progression = (arguments.length <= 1 ? undefined : arguments[2]) !== null ? arguments.length <= 2 ? undefined : arguments[2] : 0;
	  if (name === undefined || name === null) {
	    name = gUUID('##-#');
	  }
	  if (progression === undefined || progression === null) {
	    progression = 0;
	  }
	  return {
	    reference: name,
	    progression: progression,
	    progressions: [dProgression(progression, options)],
	    queue: []
	  };
	};
	var gUUID = function gUUID(seed) {
	  var s4 = function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  };
	  var uuid = '';
	  if (seed !== undefined) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	    try {
	      for (var _iterator = (0, _getIterator3.default)(seed), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var c = _step.value;
	        switch (c) {
	          case '-':
	            uuid += '-';
	            break;
	          default:
	            uuid += s4();
	            break;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  } else {
	    uuid = s4() + '-' + s4();
	  }
	  return uuid;
	};
	var gIntInclusive = function gIntInclusive(min, max) {
	  min = Math.floor(min);
	  max = Math.floor(max);
	  return Math.floor(Math.random() * (max - min + 1)) + min;
	};
	var gColor = function gColor(color) {
	  var r = {
	    min: 0,
	    max: 255
	  };
	  var g = {
	    min: 0,
	    max: 255
	  };
	  var b = {
	    min: 0,
	    max: 255
	  };
	  if (color !== undefined) {
	    if (color.r !== undefined) {
	      color.r.min !== undefined ? r.min = color.r.min : null;
	      color.r.max !== undefined ? r.max = color.r.max : null;
	    }
	    if (color.g !== undefined) {
	      color.g.min !== undefined ? g.min = color.g.min : null;
	      color.g.max !== undefined ? g.max = color.g.max : null;
	    }
	    if (color.b !== undefined) {
	      color.b.min !== undefined ? b.min = color.b.min : null;
	      color.b.max !== undefined ? b.max = color.b.max : null;
	    }
	  }
	  return 'rgb(' + gIntInclusive(r.min, r.max) + ', ' + gIntInclusive(g.min, g.max) + ', ' + gIntInclusive(b.min, b.max) + ')';
	};
	var gThickness = function gThickness(thickness) {
	  var min = 2;
	  var max = 7;
	  var suffix = 'px';
	  if (thickness !== undefined) {
	    thickness.min !== undefined ? min = thickness.min : null;
	    thickness.max !== undefined ? max = thickness.max : null;
	    thickness.suffix !== undefined ? suffix = thickness.suffix : null;
	  }
	  return gIntInclusive(min, max) + suffix;
	};
	var gTrail = function gTrail(trail) {
	  var min = 50;
	  var max = 100;
	  var suffix = 'px';
	  if (trail !== undefined) {
	    trail.min !== undefined ? min = trail.min : null;
	    trail.max !== undefined ? max = trail.max : null;
	    trail.suffix !== undefined ? suffix = trail.suffix : null;
	  }
	  return gIntInclusive(min, max) + suffix;
	};
	var gTransition = function gTransition(transition) {
	  var timeDec, opacityDec, timeInt, opacityInt, x;
	  if (transition !== undefined) {
	    if (transition.time.min !== undefined && transition.time.max !== undefined) {
	      if (transition.time.min % 1 === 0 || transition.time.max % 1 === 0) {
	        timeDec = 0;
	      } else {
	        timeDec = gIntInclusive(Math.floor(transition.time.min % 1 * 100), Math.floor(transition.time.max % 1 * 100));
	      }
	      timeInt = gIntInclusive(transition.time.min, transition.time.max);
	    } else {
	      timeInt = gIntInclusive(0, 1);
	      timeInt < 1 ? timeDec = gIntInclusive(50, 99) : timeDec = gIntInclusive(0, 50);
	    }
	    if (transition.opacity.min !== undefined && transition.opacity.max !== undefined) {
	      if (transition.opacity.min % 1 === 0 || transition.opacity.max % 1 === 0) {
	        opacityDec = 0;
	      } else {
	        opacityDec = gIntInclusive(Math.floor(transition.opacity.min % 1 * 100), Math.floor(transition.opacity.max % 1 * 100));
	      }
	      opacityInt = gIntInclusive(transition.opacity.min, transition.opacity.max);
	    } else {
	      opacityInt = gIntInclusive(0, 1);
	      opacityInt < 1 ? opacityDec = gIntInclusive(50, 99) : opacityDec = gIntInclusive(0, 50);
	    }
	  } else {
	    timeInt = gIntInclusive(0, 1);
	    opacityInt = gIntInclusive(0, 1);
	    timeInt < 1 ? timeDec = gIntInclusive(50, 99) : timeDec = gIntInclusive(0, 50);
	    opacityInt < 1 ? opacityDec = gIntInclusive(50, 99) : opacityDec = gIntInclusive(0, 50);
	  }
	  x = {
	    time: timeInt + '.' + timeDec + 's',
	    opacity: opacityInt + '.' + opacityDec + 's'
	  };
	  return x;
	};
	var gLocation = function gLocation(location) {
	  if (location !== undefined) {
	    var length = 0;
	    for (var variable in location) {
	      if (location.hasOwnProperty(variable)) {
	        length++;
	      }
	    }
	    return location[gIntInclusive(0, length - 1)];
	  } else {
	    switch (gIntInclusive(0, 3)) {
	      case 0:
	        return 'top';
	      case 1:
	        return 'bottom';
	      case 2:
	        return 'left';
	      case 3:
	        return 'right';
	    }
	  }
	};
	var gInverse = function gInverse(inverse) {
	  if (inverse !== undefined) {
	    if (Array.isArray(inverse)) {
	      var length = 0;
	      for (var variable in inverse) {
	        if (inverse.hasOwnProperty(variable)) {
	          length++;
	        }
	      }
	      return inverse[gIntInclusive(0, length - 1)];
	    } else if (typeof inverse === 'boolean') {
	      return inverse;
	    }
	  }
	  switch (gIntInclusive(0, 1)) {
	    case 0:
	      return false;
	    case 1:
	      return true;
	  }
	};
	var gBounce = function gBounce(bounce) {
	  if (bounce !== undefined) {
	    if (Array.isArray(bounce)) {
	      var length = 0;
	      for (var variable in bounce) {
	        if (bounce.hasOwnProperty(variable)) {
	          length++;
	        }
	      }
	      return bounce[gIntInclusive(0, length - 1)];
	    } else if (typeof bounce === 'boolean') {
	      return bounce;
	    }
	  }
	  switch (gIntInclusive(0, 1)) {
	    case 0:
	      return false;
	    case 1:
	      return true;
	  }
	};
	var gGradient = function gGradient(gradient, location) {
	  var from = {
	    r: { min: 0, max: 255 },
	    g: { min: 0, max: 255 },
	    b: { min: 0, max: 255 }
	  };
	  var to = {
	    r: { min: 0, max: 255 },
	    g: { min: 0, max: 255 },
	    b: { min: 0, max: 255 }
	  };
	  var direction = 'to left';
	  var use = true;
	  if (gradient !== undefined && gradient !== null) {
	    if (gradient.use !== null && gradient.use !== undefined) {
	      if (Array.isArray(gradient.use)) {
	        gradient.use ? use = true : use = false;
	      } else {
	        var length = 0;
	        for (var variable in gradient.use) {
	          if (gradient.use.hasOwnProperty(variable)) {
	            length++;
	          }
	        }
	        use = gradient.use[gIntInclusive(0, length - 1)];
	      }
	    } else {
	      switch (gIntInclusive(0, 1)) {
	        case 0:
	          use = false;
	        case 1:
	          use = true;
	      }
	    }
	    if (typeof gradient.gradient === 'string') {
	      if (gradient.gradient === 'predefined') {
	        return { use: use, gradient: 'predefined' };
	      } else if (regexGradient.test(gradient.gradient)) {
	        return { use: use, gradient: gradient.gradient };
	      }
	    }
	    if (gradient.gradient.from !== null && gradient.gradient.from !== undefined) {
	      gradient.gradient.from.r.min !== null && gradient.gradient.from.r.min !== undefined ? from.r.min = gradient.gradient.from.r.min : null;
	      gradient.gradient.from.r.max !== null && gradient.gradient.from.r.max !== undefined ? from.r.max = gradient.gradient.from.r.max : null;
	      gradient.gradient.from.g.min !== null && gradient.gradient.from.g.min !== undefined ? from.g.min = gradient.gradient.from.g.min : null;
	      gradient.gradient.from.g.max !== null && gradient.gradient.from.g.max !== undefined ? from.g.max = gradient.gradient.from.g.max : null;
	      gradient.gradient.from.b.min !== null && gradient.gradient.from.b.min !== undefined ? from.b.min = gradient.gradient.from.b.min : null;
	      gradient.gradient.from.b.max !== null && gradient.gradient.from.b.max !== undefined ? from.b.max = gradient.gradient.from.b.max : null;
	    }
	    if (gradient.gradient.to !== null && gradient.gradient.to !== undefined) {
	      gradient.gradient.to.r.min !== null && gradient.gradient.to.r.min !== undefined ? to.r.min = gradient.gradient.to.r.min : null;
	      gradient.gradient.to.r.max !== null && gradient.gradient.to.r.max !== undefined ? to.r.max = gradient.gradient.to.r.max : null;
	      gradient.gradient.to.g.min !== null && gradient.gradient.to.g.min !== undefined ? to.g.min = gradient.gradient.to.g.min : null;
	      gradient.gradient.to.g.max !== null && gradient.gradient.to.g.max !== undefined ? to.g.max = gradient.gradient.to.g.max : null;
	      gradient.gradient.to.b.min !== null && gradient.gradient.to.b.min !== undefined ? to.b.min = gradient.gradient.to.b.min : null;
	      gradient.gradient.to.b.max !== null && gradient.gradient.to.b.max !== undefined ? to.b.max = gradient.gradient.to.b.max : null;
	    }
	  } else {
	    return { use: use, gradient: 'predefined' };
	  }
	  if (location !== undefined && location !== null) {
	    if (location === 'top' || location === 'bottom') {
	      direction = 'to left';
	    } else if (location === 'left' || location === 'right') {
	      direction = 'to top';
	    }
	  }
	  from = 'rgb(' + gIntInclusive(from.r.min, from.r.max) + ', ' + gIntInclusive(from.g.min, from.g.max) + ', ' + gIntInclusive(from.b.min, from.b.max) + ')';
	  to = 'rgb(' + gIntInclusive(to.r.min, to.r.max) + ', ' + gIntInclusive(to.g.min, to.g.max) + ', ' + gIntInclusive(to.b.min, to.b.max) + ')';
	  gradient = 'linear-gradient(' + direction + ', ' + from + ', ' + to + ')';
	  return { use: use, gradient: gradient };
	};
	var regexColor = new RegExp('(^#[0-9a-fA-F]{6}$)|(^#[0-9a-fA-F]{3}$)|(^rgb\\([0-9]{1,3}, [0-9]{1,3}, [0-9]{1,3}\\)$)');
	var regexLocation = new RegExp('(left|right|top|bottom)');
	var regexTime = new RegExp('(\\d+\\.\\d+)(s|ms)|(\\.\\d+)(s|ms)|(\\d+)(s|ms)');
	var regexThickness = new RegExp('(\\d+\\.\\d+)(px|em|pt|%|vh|vw)|(\\.\\d+)(px|em|pt|%|vh|vw)|(\\d+)(px|em|pt|%|vh|vw)');
	var regexTrail = new RegExp('(\\d+\\.\\d+)(px|em|pt|%|vh|vw)|(\\.\\d+)(px|em|pt|%|vh|vw)|(\\d+)(px|em|pt|%|vh|vw)');
	var regexGradient = new RegExp('(predefined)|((linear-gradient)\\(to (top|bottom|left|right), (rgb\\([0-9]{1,3}, [0-9]{1,3}, [0-9]{1,3}\\)|#[a-zA-Z0-9]{6}|#[a-zA-Z0-9]{3}|), (rgb\\([0-9]{1,3}, [0-9]{1,3}, [0-9]{1,3}\\)|#[a-zA-Z0-9]{6}|#[a-zA-Z0-9]{3}|)\\))');
	var hValidColor = function hValidColor(color) {
	  return regexColor.test(color);
	};
	var hValidLocation = function hValidLocation(location) {
	  return regexLocation.test(location);
	};
	var hValidTime = function hValidTime(time) {
	  return regexTime.test(time);
	};
	var hValidThickness = function hValidThickness(thickness) {
	  return regexThickness.test(thickness);
	};
	var hValidTrail = function hValidTrail(trail) {
	  return regexTrail.test(trail);
	};
	var hValidGradient = function hValidGradient(gradient) {
	  return regexGradient.test(gradient);
	};
	var hValidate = function hValidate() {
	  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    args[_key4] = arguments[_key4];
	  }
	
	  if (args !== undefined && args[0] !== undefined && args[1] !== undefined) {
	    switch (args[0]) {
	      case 'color':
	        return hValidColor(args[1]);
	      case 'fail':
	        return hValidColor(args[1]);
	      case 'location':
	        return hValidLocation(args[1]);
	      case 'time':
	        return hValidTime(args[1]);
	      case 'thickness':
	        return hValidThickness(args[1]);
	      case 'trail':
	        return hValidTrail(args[1]);
	      case 'inverse':
	        return typeof args[1] === 'boolean';
	      case 'bounce':
	        return typeof args[1] === 'boolean';
	      case 'transition':
	        return hValidTime(args[1].time) && hValidTime(args[1].opacity);
	      case 'gradient':
	        return hValidGradient(args[1].gradient);
	    }
	  } else {
	    fLog(b, 'Error: not enough arguments');
	  }
	};
	var hSetFailColor = function hSetFailColor(progressbar, color, temp) {
	  if (temp) {
	    progressbar.$root.temp.failedColor = color;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.failedColor = color;
	  }
	};
	var hSetColor = function hSetColor(progressbar, color, temp) {
	  if (temp) {
	    progressbar.$root.temp.color = color;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.color = color;
	  }
	};
	var hSetLocation = function hSetLocation(progressbar, loc, temp) {
	  if (temp) {
	    progressbar.$root.temp.location = loc;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.location = loc;
	  }
	};
	var hSetTransition = function hSetTransition(progressbar, transition, temp) {
	  if (temp) {
	    progressbar.$root.temp.transition = transition;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.transition = transition;
	  }
	};
	var hSetInverse = function hSetInverse(progressbar, inverse, temp) {
	  if (temp) {
	    progressbar.$root.temp.inverse = inverse;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.inverse = inverse;
	  }
	};
	var hSetThickness = function hSetThickness(progressbar, thickness, temp) {
	  if (temp) {
	    progressbar.$root.temp.thickness = thickness;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.thickness = thickness;
	  }
	};
	var hSetTrail = function hSetTrail(progressbar, trail, temp) {
	  if (temp) {
	    progressbar.$root.temp.trail = trail;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.trail = trail;
	  }
	};
	var hSetBounce = function hSetBounce(progressbar, bounce, temp) {
	  if (temp) {
	    progressbar.$root.temp.bounce = bounce;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.bounce = bounce;
	  }
	};
	var hSetGradient = function hSetGradient(progressbar, gradient, temp) {
	  if (temp) {
	    progressbar.$root.temp.gradient = gradient;
	    progressbar.$root.temp.use ? progressbar.$root.temp.use = true : null;
	  } else {
	    progressbar.$root.options.gradient = gradient;
	  }
	};
	var hSet = function hSet() {
	  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    args[_key5] = arguments[_key5];
	  }
	
	  args[1] === 'color' ? hSetColor(args[0], args[2], args[3]) : null;
	  args[1] === 'fail' ? hSetFailColor(args[0], args[2], args[3]) : null;
	  args[1] === 'location' ? hSetLocation(args[0], args[2], args[3]) : null;
	  args[1] === 'transition' ? hSetTransition(args[0], {
	    time: args[2].time,
	    opacity: args[2].opacity
	  }, args[3]) : null;
	  args[1] === 'inverse' ? hSetInverse(args[0], args[2], args[3]) : null;
	  args[1] === 'thickness' ? hSetThickness(args[0], args[2], args[3]) : null;
	  args[1] === 'trail' ? hSetTrail(args[0], args[2], args[3]) : null;
	  args[1] === 'bounce' ? hSetBounce(args[0], args[2], args[3]) : null;
	  args[1] === 'gradient' ? hSetGradient(args[0], {
	    use: args[2].use,
	    gradient: args[2].gradient
	  }, args[3]) : null;
	};
	
	var fLog = function fLog(progressbar, message) {
	  if (progressbar.state.settings.debug) {
	    console.log(message);
	  }
	};
	var fInit = function fInit(progressbar, data) {
	  progressbar.$root = data;
	  progressbar.state.settings = progressbar.$root.options;
	  progressbar.$root.initiated = true;
	};
	var fStart = function fStart(progressbar, time) {
	  progressbar.$root.temp.use ? progressbar.state.settings = progressbar.$root.temp : progressbar.state.settings = progressbar.$root.options;
	  if (!time) {
	    if (hValidate('time', progressbar.state.settings.transition.time)) {
	      progressbar.state.pTime = parseFloat(progressbar.state.settings.transition.time.replace('/(ms|s)/'));
	      if (!progressbar.state.settings.transition.time.includes('ms')) {
	        progressbar.state.pTime *= 1000;
	      }
	      time = progressbar.state.pTime;
	    } else {
	      fLog(progressbar, 'invalid time: ' + progressbar.state.settings.transition.time);
	      fLog(progressbar, 'valid formats: ##, #.#, .# [ms|s]');
	      fLog(progressbar, 'example: 1000ms, 1.0s, .10ms');
	      progressbar.state.pTime = time = 3000;
	    }
	  }
	  if (!progressbar.$root) return;
	  progressbar.$root.hidden = false;
	  progressbar.$root.quicklyHid = false;
	  progressbar.$root.started = true;
	  progressbar.state.settings.show = true;
	  progressbar.state.settings.canSuccess = true;
	  progressbar.state.cut = 10000 / Math.floor(time);
	  var progressbar2 = progressbar;
	  progressbar.state.timer = setInterval(function () {
	    if (progressbar2.state.timer !== null) {
	      fIncrease(progressbar2, progressbar2.state.cut * Math.random());
	      if (progressbar2.$root.percent > 95 && !progressbar2.$root.quicklyHid) {
	        fFinish(progressbar2);
	      }
	    }
	  }, 100);
	};
	var fSet = function fSet(progressbar, num) {
	  progressbar.state.settings.show = true;
	  progressbar.state.settings.canSuccess = true;
	  progressbar.$root.percent = Math.floor(num);
	};
	var fGet = function fGet(progressbar) {
	  return Math.floor(progressbar.$root.percent);
	};
	var fIncrease = function fIncrease(progressbar, num) {
	  progressbar.$root.percent = progressbar.$root.percent + Math.floor(num);
	};
	var fDecrease = function fDecrease(progressbar, num) {
	  progressbar.$root.percent = progressbar.$root.percent - Math.floor(num);
	};
	var fReadyToRevert = function fReadyToRevert(progressbar) {
	  if (progressbar.$root.hidden || progressbar.$root.quickHide) {
	    fRevert(progressbar);
	  } else {
	    (function () {
	      var progressbar2 = progressbar;
	      progressbar.state.revertTimer = setTimeout(function () {
	        fLog(progressbar2, 'not ready');
	        fReadyToRevert(progressbar2);
	      }, 500);
	    })();
	  }
	};
	var fRevert = function fRevert(progressbar) {
	  fLog(progressbar, 'revert');
	  progressbar.$root.temp = {
	    use: false,
	    debug: progressbar.$root.options.debug,
	    canSuccess: progressbar.$root.options.canSuccess,
	    show: progressbar.$root.options.show,
	    color: progressbar.$root.options.color,
	    failedColor: progressbar.$root.options.failedColor,
	    thickness: progressbar.$root.options.thickness,
	    autoRevert: progressbar.$root.options.autoRevert,
	    location: progressbar.$root.options.location,
	    inverse: progressbar.$root.options.inverse,
	    transition: progressbar.$root.options.transition,
	    trail: progressbar.$root.options.trail,
	    gradient: progressbar.$root.options.gradient,
	    bounce: progressbar.$root.options.bounce
	  };
	};
	var fQuickHide = function fQuickHide(progressbar) {
	  if (progressbar.$root.finished) return false;
	  clearInterval(progressbar.state.timer);
	  progressbar.state.timer = null;
	  if (progressbar.state.hideTimer !== null) {
	    clearTimeout(progressbar.state.hideTimer);
	    clearTimeout(progressbar.state.hideTimer2);
	    progressbar.state.hideTimer2 = null;
	    progressbar.state.hideTimer = null;
	  }
	  progressbar.$root.quickHide = true;
	  progressbar.$root.percent = 0;
	  progressbar.$root.hidden = true;
	  if (progressbar.state.settings.autoRevert && progressbar.$root.temp.use) {
	    clearTimeout(progressbar.state.revertTimer);
	    progressbar.state.revertTimer = null;
	    fRevert(progressbar);
	  }
	  progressbar.$root.finished = true;
	  return true;
	};
	var fHide = function fHide(progressbar) {
	  clearInterval(progressbar.state.timer);
	  progressbar.state.timer = null;
	  var progressbar2 = progressbar;
	  progressbar.state.hideTimer = setTimeout(function () {
	    if (!progressbar2.$root.finished) {
	      progressbar2.$root.options.show = false;
	      if (progressbar2.state.settings.bounce) {
	        progressbar2.$root.percent = 0;
	      }
	      if (progressbar2.state.settings.autoRevert && progressbar2.$root.temp.use) {
	        fReadyToRevert(progressbar);
	      }
	      progressbar2.state.hideTimer2 = setTimeout(function () {
	        if (!progressbar2.$root.finished) {
	          if (progressbar2.$root.percent !== 0) {
	            progressbar2.$root.percent = 0;
	          }
	          progressbar2.$root.hidden = true;
	          progressbar2.$root.finished = true;
	        }
	      }, progressbar2.state.pTime);
	    }
	  }, progressbar2.state.pTime);
	};
	var fPause = function fPause(progressbar) {
	  clearInterval(progressbar.state.timer);
	};
	var fFinish = function fFinish(progressbar) {
	  if (!progressbar.$root || progressbar.$root.finished) return;
	  progressbar.$root.percent = 100;
	  fHide(progressbar);
	};
	var fFail = function fFail(progressbar, customColor) {
	  progressbar.state.settings.canSuccess = false;
	  progressbar.$root.percent = 100;
	  fHide(progressbar);
	};
	var fCallMeta = function fCallMeta() {
	  fCall(arguments.length <= 0 ? undefined : arguments[0], 'set', arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 3 ? undefined : arguments[3], (arguments.length <= 2 ? undefined : arguments[2]) === 'temp');
	};
	var fCallSetTemp = function fCallSetTemp() {
	  if ((arguments.length <= 1 ? undefined : arguments[1]) !== undefined && (arguments.length <= 2 ? undefined : arguments[2]) !== undefined && (arguments.length <= 3 ? undefined : arguments[3]) !== undefined) {
	    hValidate(arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]) ? hSet(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 3 ? undefined : arguments[3]) : fLog(arguments.length <= 0 ? undefined : arguments[0], 'invalid \'' + (arguments.length <= 1 ? undefined : arguments[1]) + '\' input: \'' + (arguments.length <= 2 ? undefined : arguments[2]) + '\'');
	  }
	};
	var fCallRevert = function fCallRevert(progressbar, revert) {
	  hSet(progressbar, revert, progressbar.$root.options.color, true);
	};
	var fCall = function fCall() {
	  var temp = ((arguments.length <= 1 ? undefined : arguments[1]) === 'temp' || (arguments.length <= 1 ? undefined : arguments[1]) === 'set') && (arguments.length <= 4 ? undefined : arguments[4]) !== undefined ? temp = arguments.length <= 4 ? undefined : arguments[4] : temp = null;
	  switch (arguments.length <= 1 ? undefined : arguments[1]) {
	    case 'meta':
	      fCallMeta(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 3 ? undefined : arguments[3], arguments.length <= 4 ? undefined : arguments[4]);
	      break;
	    case 'temp':
	      if (temp === null) temp = true;
	      fCallSetTemp(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 3 ? undefined : arguments[3], temp);
	      break;
	    case 'set':
	      if (temp === null) temp = false;
	      fCallSetTemp(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 2 ? undefined : arguments[2], arguments.length <= 3 ? undefined : arguments[3], temp);
	      break;
	    case 'revert':
	      fCallRevert(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 2 ? undefined : arguments[2]);
	      break;
	  }
	};
	var fParseMeta = function fParseMeta(progressbar, meta) {
	  for (var x in meta.func) {
	    fCall(progressbar, 'meta', meta.func[x].call, meta.func[x].modifier, meta.func[x].argument);
	  }
	};
	var fRandomize = function fRandomize(progressbar, meta) {
	  var data = {
	    color: null,
	    fail: null,
	    thickness: null,
	    location: null,
	    inverse: null,
	    transition: null,
	    trail: null,
	    bounce: null,
	    gradient: null
	  };
	  data.color = meta !== undefined && meta.color !== undefined ? gColor(meta.color) : gColor();
	  data.fail = meta !== undefined && meta.fail !== undefined ? gColor(meta.fail) : gColor();
	  data.thickness = meta !== undefined && meta.thickness !== undefined ? gThickness(meta.thickness) : gThickness();
	  data.location = meta !== undefined && meta.location !== undefined ? gLocation(meta.location) : gLocation();
	  data.inverse = meta !== undefined && meta.inverse !== undefined ? gInverse(meta.inverse) : gInverse();
	  data.transition = meta !== undefined && meta.transition !== undefined ? gTransition(meta.transition) : gTransition();
	  data.trail = meta !== undefined && meta.trail !== undefined ? gTrail(meta.trail) : gTrail();
	  data.bounce = meta !== undefined && meta.bounce !== undefined ? gBounce(meta.bounce) : gBounce();
	  data.gradient = meta !== undefined && meta.gradient !== undefined ? gGradient(meta.gradient, data.location) : gGradient(null, data.location);
	  var unparsed = {
	    func: [{
	      call: 'color',
	      modifier: 'temp',
	      argument: data.color
	    }, {
	      call: 'fail',
	      modifier: 'temp',
	      argument: data.fail
	    }, {
	      call: 'thickness',
	      modifier: 'temp',
	      argument: data.thickness
	    }, {
	      call: 'location',
	      modifier: 'temp',
	      argument: data.location
	    }, {
	      call: 'inverse',
	      modifier: 'temp',
	      argument: data.inverse
	    }, {
	      call: 'transition',
	      modifier: 'temp',
	      argument: data.transition
	    }, {
	      call: 'trail',
	      modifier: 'temp',
	      argument: data.trail
	    }, {
	      call: 'bounce',
	      modifier: 'temp',
	      argument: data.bounce
	    }, {
	      call: 'gradient',
	      modifier: 'temp',
	      argument: data.gradient
	    }]
	  };
	  fParseMeta(progressbar, unparsed);
	};
	var fProgress = function fProgress(bar, options) {
	  for (var x = 0; x < bar.queue.length; x++) {
	    if (bar.progressions[bar.queue[x]].data.finished) {
	      bar.queue.splice(x, 1);
	    }
	  }
	  bar.progressions.push(dProgression(++bar.progression, options));
	  bar.progressions[bar.progression].bar.init(bar.progressions[bar.progression].data);
	};
	var install = function install(Vue) {
	  var version = function version() {
	    return '2.x.x';
	  };
	  var vueVersion = function vueVersion() {
	    return Vue.version;
	  };
	  var versionCheck = function versionCheck() {
	    return vueVersion().split('.')[0] === version().split('.')[0];
	  };
	  var OPTIONS = (arguments.length <= 1 ? undefined : arguments[1]) !== undefined ? arguments.length <= 1 ? undefined : arguments[1] : undefined;
	  if (versionCheck()) {
	    console.log('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Version verified!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	  } else {
	    console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	    return;
	  }
	  var ProgressBarBus = new Vue({
	    data: {
	      bars: [],
	      queue: [],
	      startTimer: null,
	      startTimer2: null,
	      startTimer3: null
	    },
	    methods: {
	      version: function version() {
	        return versionCheck();
	      },
	      init: function init(name) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (!bar.progressions[bar.progression].data.initiated) {
	              bar.progressions[bar.progression].data.initiated = true;
	              bar.progressions[bar.progression].bar.init(bar.progressions[bar.progression].data);
	              if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Initialized!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            } else {
	              console.log('[%cProgressBar%c][%c' + bar.reference + '%c] Already initialized!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to quick hide.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      get: function get(name) {
	        if (versionCheck()) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(this.bars), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var bar = _step2.value;
	
	              if (bar.reference === name) {
	                return bar;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          return null;
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      create: function create(name, options) {
	        if (versionCheck()) {
	          if (options === undefined) {
	            if (OPTIONS === undefined) {
	              options = {};
	            } else {
	              options = OPTIONS;
	            }
	          }
	          var bar = name;
	          bar = this.get(bar);
	          if (bar !== null && bar !== undefined) {
	            console.error('[%cProgressBar%c][%c' + bar.reference + '%c] Already exists! Creation denied.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            return null;
	          }
	          bar = gProgressBar(name, options);
	          this.bars.push(bar);
	          console.log('[%cProgressBar%c][%c' + bar.reference + '%c] Added!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          if (bar.progressions[bar.progression].data.init) {
	            bar.progressions[bar.progression].data.init = false;
	            this.init(bar);
	            return bar.reference;
	          } else {
	            console.log('[%cProgressBar%c][%c' + bar.reference + '%c] Manual initialization required!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            return bar.reference;
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      start: function start(name, options, modifier) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (bar.progressions[bar.progression].data.started) {
	                var this2 = this;
	                this.quickHide(bar);
	                this2.startTimer = setTimeout(function () {
	                  if (options !== null && options !== undefined) {
	                    if (modifier !== null && modifier !== undefined) {
	                      if (modifier === 'randomize') {
	                        bar.progressions[bar.progression].bar.randomize(options);
	                        this2.startTimer2 = setTimeout(function () {
	                          this2.progress(bar, bar.progressions[bar.progression].data.temp);
	                          this2.startTimer3 = setTimeout(function () {
	                            bar.queue.push(bar.progression);
	                            bar.progressions[bar.progression].bar.start();
	                            if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                              console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                            }
	                          }, 100);
	                        }, 100);
	                      } else if (modifier === 'meta') {
	                        this2.modify(bar, options);
	
	                        this2.startTimer2 = setTimeout(function () {
	                          this2.progress(bar, bar.progressions[bar.progression].data.temp);
	                          this2.startTimer3 = setTimeout(function () {
	                            bar.queue.push(bar.progression);
	                            bar.progressions[bar.progression].bar.start();
	                            if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                              console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                            }
	                          }, 100);
	                        }, 100);
	                      }
	                    } else {
	                      this2.progress(bar, options);
	                      bar.queue.push(bar.progression);
	                      bar.progressions[bar.progression].bar.start();
	                      if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                        console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                      }
	                    }
	                  } else {
	                    this2.progress(bar);
	                    bar.queue.push(bar.progression);
	                    bar.progressions[bar.progression].bar.start();
	                    if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                      console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                    }
	                  }
	                }, 100);
	              } else {
	                this.progress(bar);
	                bar.queue.push(bar.progression);
	                bar.progressions[bar.progression].bar.start();
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              }
	            } else {
	              console.error('[%cProgressBar%c][%c' + bar.reference + '%c] Failed to start! Manual initialization required!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to start.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      finish: function finish(name) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            var key = bar.queue.shift();
	            if (key !== null && key !== undefined) {
	              if (bar.progressions[key] !== null && bar.progressions[key] !== undefined) {
	                if (bar.progressions[key].data.initiated) {
	                  if (bar.progressions[key].data.started && !bar.progressions[key].data.finished) {
	                    bar.progressions[key].bar.finish();
	                    console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + key + '%c] Finished!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  } else {
	                    console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + key + '%c] Failed to finish! Either not started or already finished!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  }
	                } else {
	                  if (bar.progressions[key].data.temp.debug || bar.progressions[key].data.options.debug) {
	                    console.error('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + key + '%c] Failed to finish! Manual initialization required!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  }
	                }
	              } else {
	                console.warn('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + key + '%c] Failed to finish! already on progression: [%c' + bar.progression + '%c]', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            } else {
	              console.warn('[%cProgressBar%c][%c' + bar.reference + '%c] Failed to finish! already on progression: [%c' + bar.progression + '%c]', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to finish.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      fail: function fail(name) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (bar.progressions[bar.progression].data.started && !bar.progressions[bar.progression].data.finished) {
	                bar.progressions[bar.progression].bar.fail();
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              } else {
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to fail! Either not started or already finished!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              }
	            } else {
	              if (bar.progressions[bar.progression].data.temp.debug || bar.progressions[bar.progression].data.options.debug) {
	                console.error('[%cProgressBar%c][%c' + bar.reference + '%c] Failed to fail! Manual initialization required!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to fail.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      quickHide: function quickHide(name) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (bar.progressions[bar.progression].data.started) {
	                if (bar.progressions[bar.progression].bar.quickHide()) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Quickly Hidden!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  return true;
	                } else {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to quickhide! already hidden!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              } else {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to quickhide, bar not started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            } else {
	              if (bar.progressions[bar.progression].data.temp.debug || bar.progressions[bar.progression].data.options.debug) {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to quickhide! Manual initialization required!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to quick hide.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	        return false;
	      },
	      randomize: function randomize(name, meta) {
	        if (versionCheck()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (meta === undefined) {
	              meta = {};
	            }
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (!bar.progressions[bar.progression].data.started) {
	                bar.progressions[bar.progression].bar.randomize(meta);
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Randomized!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              } else {
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Cannot randomize after bar has started!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              }
	            } else {
	              if (bar.progressions[bar.progression].data.temp.debug || bar.progressions[bar.progression].data.options.debug) {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to randomize! Manual initialization required', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to quick hide.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      destroy: function destroy(name) {
	        if (this.version()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            this.bars.slice(this.bars.indexOf(bar));
	            if (bar.progressions[bar.progression].data.initiated && bar.progressions[bar.progression].bar.state.settings.debug || bar.progressions[bar.progression].data.options.debug || bar.progressions[bar.progression].data.temp.use && bar.progressions[bar.progression].data.temp.debug) {
	              console.log('[%cProgressBar%c][%c' + bar.reference + '%c] Destroyed and no longer accessable!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	            }
	            return true;
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to destroy.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	        return false;
	      },
	      progress: function progress(name, options) {
	        if (this.version()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          } else {
	            bar = name;
	          }
	          if (bar !== null && bar !== undefined) {
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (options === null || options === undefined) {
	                options = bar.progressions[bar.progression].bar.state.settings;
	              }
	              bar.progressions[bar.progression].bar.progress(bar, options);
	              if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Progressed!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            } else {
	              if (options === null || options === undefined) {
	                if (bar.progressions[bar.progression].data.temp.use) {
	                  bar.progressions[bar.progression].bar.progress(bar, bar.progressions[bar.progression].data.temp);
	                  if (bar.progressions[bar.progression].data.temp.debug) {
	                    console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Progressed!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  }
	                } else {
	                  bar.progressions[bar.progression].bar.progress(bar, bar.progressions[bar.progression].data.options);
	                  if (bar.progressions[bar.progression].data.options.debug) {
	                    console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Progressed!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                  }
	                }
	              } else {
	                bar.progressions[bar.progression].bar.progress(bar, options);
	                if (bar.progressions[bar.progression].data.temp.use && bar.progressions[bar.progression].data.temp.debug || bar.progressions[bar.progression].data.options.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Progressed!', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              }
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to quick hide.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      },
	      modify: function modify(name, meta) {
	        if (this.version()) {
	          var bar = name;
	          if (typeof bar === 'string') {
	            bar = this.get(bar);
	          }
	          if (bar !== null && bar !== undefined) {
	            if (bar.progressions[bar.progression].data.initiated) {
	              if (meta !== null && meta !== undefined) {
	                if (!Array.isArray(meta)) {
	                  meta = { func: [meta] };
	                } else {
	                  meta = { func: meta };
	                }
	                bar.progressions[bar.progression].bar.parseMeta(meta);
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Modified!', 'color: ' + gColor() + ';', 'color: ' + gColor() + ';', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              } else {
	                if (bar.progressions[bar.progression].bar.state.settings.debug) {
	                  console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Not Modified! No meta data defined!', 'color: ' + gColor() + ';', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	                }
	              }
	            } else {
	              if (bar.progressions[bar.progression].data.temp.debug || bar.progressions[bar.progression].data.options.debug) {
	                console.log('[%cProgressBar%c][%c' + bar.reference + '%c-%c' + bar.progression + '%c] Failed to randomize! Manual initialization required', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	              }
	            }
	          } else {
	            console.error('[%cProgressBar%c][%c' + name + '%c] Does not exist! Failed to modify.', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	          }
	        } else {
	          console.error('[%cProgressBar%c][%cVueJS%c-%c' + Vue.version + '%c] Out of date! Please update to \'v%c2.x%c\'', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;', 'color: ' + gColor() + ';', 'color: #000;');
	        }
	      }
	    }
	  });
	  Vue.component('vue-progress-bar', _vueProgressbar2.default);
	  Vue.prototype.$pb = ProgressBarBus;
	};
	
	exports.default = install;

/***/ },

/***/ 59:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 60:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 61:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 62:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 63:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(61)
	
	/* script */
	__vue_exports__ = __webpack_require__(24)
	
	/* template */
	var __vue_template__ = __webpack_require__(68)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 64:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(60)
	
	/* script */
	__vue_exports__ = __webpack_require__(25)
	
	/* template */
	var __vue_template__ = __webpack_require__(67)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2079b4f6"
	
	module.exports = __vue_exports__


/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(59)
	
	/* script */
	__vue_exports__ = __webpack_require__(26)
	
	/* template */
	var __vue_template__ = __webpack_require__(66)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 66:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    class: _vm.classStyle,
	    style: (_vm.style),
	    attrs: {
	      "show": _vm.show,
	      "options": _vm.options,
	      "reference": _vm.reference
	    }
	  })
	},staticRenderFns: []}

/***/ },

/***/ 67:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "hello"
	  }, [_vm._h('vue-progress-bar', {
	    attrs: {
	      "show": true,
	      "reference": "example"
	    }
	  }), " ", _vm._h('table', {
	    attrs: {
	      "id": "links-list"
	    }
	  }, [_vm._h('tr', [_vm._h('td', {
	    staticClass: "container primary"
	  }, [_vm._h('div', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.start('example')
	      }
	    }
	  }, ["Start"])]), " ", _vm._h('td', {
	    staticClass: "container secondary"
	  }, [_vm._h('div', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.finish('example')
	      }
	    }
	  }, ["Finish"])]), " ", _vm._h('td', {
	    staticClass: "container danger"
	  }, [_vm._h('div', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.fail('example')
	      }
	    }
	  }, ["Fail"])])]), " ", _vm._h('tr', [_vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.trail.use),
	      expression: "trail.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.trail.use) ? _vm._i(_vm.trail.use, null) > -1 : _vm._q(_vm.trail.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.trail.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.trail.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.trail.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.trail.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.trail.use = !_vm.trail.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.trail), _vm._m(0)]), " ", (_vm.trail.use) ? _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.trail.data),
	      expression: "trail.data"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "100",
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm._s(_vm.trail.data)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.trail.data = _vm._n($event.target.value)
	      }
	    }
	  }) : _vm._e(), " "]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thickness.use),
	      expression: "thickness.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.thickness.use) ? _vm._i(_vm.thickness.use, null) > -1 : _vm._q(_vm.thickness.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.thickness.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.thickness.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.thickness.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.thickness.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.thickness.use = !_vm.thickness.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.thickness), _vm._m(1)]), " ", (_vm.thickness.use) ? _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thickness.data),
	      expression: "thickness.data"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "10",
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm._s(_vm.thickness.data)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.thickness.data = _vm._n($event.target.value)
	      }
	    }
	  }) : _vm._e(), " "]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.color.use),
	      expression: "color.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.color.use) ? _vm._i(_vm.color.use, null) > -1 : _vm._q(_vm.color.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.color.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.color.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.color.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.color.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.color.use = !_vm.color.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.sColor), _vm._m(2)]), " ", (_vm.color.use) ? _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.color.data),
	      expression: "color.data"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "#00A1FF",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.color.data)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.color.data = $event.target.value
	      }
	    }
	  }) : _vm._e(), " "])]), " ", _vm._h('tr', [_vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.gradient.use),
	      expression: "gradient.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.gradient.use) ? _vm._i(_vm.gradient.use, null) > -1 : _vm._q(_vm.gradient.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.gradient.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.gradient.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.gradient.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.gradient.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.gradient.use = !_vm.gradient.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.gradient), _vm._m(3)]), " ", (_vm.gradient.use) ? _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.gradient.data),
	      expression: "gradient.data"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "predefined",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.gradient.data)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.gradient.data = $event.target.value
	      }
	    }
	  }) : _vm._e(), " "]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.failColor.use),
	      expression: "failColor.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.failColor.use) ? _vm._i(_vm.failColor.use, null) > -1 : _vm._q(_vm.failColor.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.failColor.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.failColor.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.failColor.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.failColor.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.failColor.use = !_vm.failColor.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.fColor), _vm._m(4)]), " ", (_vm.failColor.use) ? _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.failColor.data),
	      expression: "failColor.data"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "red",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.failColor.data)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.failColor.data = $event.target.value
	      }
	    }
	  }) : _vm._e(), " "]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transition.use),
	      expression: "transition.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.transition.use) ? _vm._i(_vm.transition.use, null) > -1 : _vm._q(_vm.transition.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.transition.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.transition.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.transition.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.transition.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.transition.use = !_vm.transition.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.transition)]), " ", (_vm.transition.use) ? _vm._h('span', {
	    staticClass: "text"
	  }, [_vm._m(5), "Time ", _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transition.time),
	      expression: "transition.time"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "2",
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm._s(_vm.transition.time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.transition.time = _vm._n($event.target.value)
	      }
	    }
	  })]) : _vm._e(), " ", (_vm.transition.use) ? _vm._h('span', {
	    staticClass: "text"
	  }, [_vm._m(6), "Opacity ", _vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.transition.opacity),
	      expression: "transition.opacity"
	    }],
	    staticClass: "data",
	    attrs: {
	      "placeholder": "2",
	      "type": "number"
	    },
	    domProps: {
	      "value": _vm._s(_vm.transition.opacity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.transition.opacity = _vm._n($event.target.value)
	      }
	    }
	  })]) : _vm._e(), " "])]), " ", _vm._h('tr', [_vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.locations.location),
	      expression: "locations.location"
	    }],
	    staticClass: "text",
	    on: {
	      "change": function($event) {
	        _vm.locations.location = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_vm._m(7), " ", _vm._m(8), " ", _vm._m(9), " ", _vm._m(10)])]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bounce.use),
	      expression: "bounce.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.bounce.use) ? _vm._i(_vm.bounce.use, null) > -1 : _vm._q(_vm.bounce.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.bounce.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.bounce.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.bounce.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.bounce.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.bounce.use = !_vm.bounce.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.bounce)]), " "]), " ", _vm._h('td', {
	    staticClass: "container default"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inverse.use),
	      expression: "inverse.use"
	    }],
	    staticClass: "check",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.inverse.use) ? _vm._i(_vm.inverse.use, null) > -1 : _vm._q(_vm.inverse.use, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.inverse.use,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.inverse.use = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.inverse.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.inverse.use = $$c
	        }
	      }
	    }
	  }), _vm._h('span', {
	    staticClass: "text",
	    on: {
	      "click": function($event) {
	        _vm.inverse.use = !_vm.inverse.use
	      }
	    }
	  }, [_vm._s(_vm.checkboxes.inverse)]), " "])])])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('option', {
	    attrs: {
	      "value": "top"
	    }
	  }, ["Top"])
	},function (){var _vm=this;
	  return _vm._h('option', {
	    attrs: {
	      "value": "bottom"
	    }
	  }, ["Bottom"])
	},function (){var _vm=this;
	  return _vm._h('option', {
	    attrs: {
	      "value": "left"
	    }
	  }, ["Left"])
	},function (){var _vm=this;
	  return _vm._h('option', {
	    attrs: {
	      "value": "right"
	    }
	  }, ["Right"])
	}]}

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._m(2), " ", _vm._h('hello')])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('h1', {
	    staticClass: "title"
	  }, ["Vue-progressbar"])
	},function (){var _vm=this;
	  return _vm._h('h3', {
	    staticClass: "sub title"
	  }, ["A robust progress bar for VueJS 2.0"])
	},function (){var _vm=this;
	  return _vm._h('img', {
	    attrs: {
	      "src": __webpack_require__(62)
	    }
	  })
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.2492175f63d294e8497d.js